import React from "react";
import { FaAws, FaNodeJs } from "react-icons/fa";
import {
  SiMongodb,
  SiExpress,
  SiReact,
  SiNextdotjs,
  SiOpenai,
  SiZapier,
} from "react-icons/si";

const TechStack = () => {
  const techs = [
    { name: "AI / ML", icon: <SiOpenai /> },
    { name: "MongoDB", icon: <SiMongodb /> },
    { name: "Express.js", icon: <SiExpress /> },
    { name: "React.js", icon: <SiReact /> },
    { name: "Node.js", icon: <FaNodeJs /> },
    { name: "Next.js", icon: <SiNextdotjs /> },
    { name: "AWS / Cloud", icon: <FaAws /> },
    { name: "Automation Tools", icon: <SiZapier /> },
  ];

  return (
    <section className="backdiv">

      <div className="techstack-slider">
        <div className="techstack-track">
          {[...techs, ...techs].map((tech, index) => (
            <div className="tech-card" key={index}>
                <div>
              <div className="tech-icon">{tech.icon}</div>
              <span className="tech-name">{tech.name}</span>
            </div>
             </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;